<template>
  <div>
    <el-button @click="goBack" class="navbar-back-navigation-item">
      <span class="plus-icon"
        ><img src="@/assets/images/icons/arrow-left.svg" alt="" /></span
      >Back
    </el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {
      emrOrderRouteNames: [
        "View-Case-Information",
        "Finalized-Reports",
        "View-Configuration",
        "ViewEmrOrders",
      ],
      resultFilesViewProgressRouteNames: [
        "viewprogress",
        "ToStartResultFilesViewProgress",
        "ProcessingResultFilesViewProgress",
        "FailedResultFilesViewProgress",
        "CompletedResultFiles",
      ],
      qcChartRouteNames: ["QCChartFileUpload"],
      labTestPanelRoute: ["LabUsers", "TestPanel"],
      bulkAccessionViewRouteName: [
        "BulkAccessionsInfo",
        "PendingBulkAccessionView",
        "FailedBulkAccessionView",
        "CompleteBulkAccessionView",
      ],
    };
  },
  methods: {
    goBack() {
      try {
        if (this.$route.query && this.$route.query.redirectRoute) {
          let query = this.$route.query;
          let redirectRoute = this.$route.query.redirectRoute;
          delete query.redirectRoute;
          this.$router.push({
            name: redirectRoute,
            query: query,
          });
        } else if (
          this.$route.query &&
          this.$route.query.redirectRoute &&
          this.$route.query.params
        ) {
          let query = this.$route.query;
          let params = this.$route.query.params;
          let redirectRoute = this.$route.query.redirectRoute;
          delete query.redirectRoute;
          this.$router.push({
            name: redirectRoute,
            query: query,
            params: params,
          });
        } else if (
          (this.$route.query && this.$route.query.selectedPageSize) ||
          this.$route.query.selectedPage
        ) {
          this.$router.push({
            path: "/all-cases",
            query: {
              selectedCase: this.$route.query.selectedCase,
              selectedPage: this.$route.query.selectedPage,
              selectedHospital: this.$route.query.selectedHospital,
              selectedPhysician: this.$route.query.selectedPhysician,
              selectedStatus: this.$route.query.selectedStatus,
              selectedPageSize: this.$route.query.selectedPageSize,
              selectedString: this.$route.query.selectedString,
              selectedSearchBy: this.$route.query.selectedSearchBy,
              selectedDateOfBirth: this.$route.query.selectedDateOfBirth,
              selectedCaseOrderBy: this.$route.query.selectedCaseOrderBy,
              selectedCaseOrderType: this.$route.query.selectedCaseOrderType,
            },
          });
        } else {
          return this.$router.go(-1);
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss">
.navbar-back-navigation-item {
  padding: 7px 15px;
  min-height: auto;
  color: #333;
  font-weight: 500;
  border-radius: 30px;
  transition: all 0.2s ease-in-out;
  font-size: 0.9em;
  text-transform: uppercase;
  border: 1.13636px solid #d9d9d9;

  span {
    &:nth-child(1) {
      display: flex;
      align-items: center;
      img {
        width: 15px;
      }
    }
  }
  .plus-icon {
    margin-right: 7px;
  }
  &:hover {
    background: #f2f2f2;
    color: #0a5da6;
  }
}
</style>
